import useExistList from './useExistList';
import { ActionsComp } from 'components';
import { Table, TableBody, TableContainer } from 'components/mui';
import { TableHead, TablePagination, TableRow, TableCell } from 'components/mui';
import { estContactsType } from 'containers/pages/users/types';
import * as TY from 'containers/pages/users/constants';
import styles from './ExistList.module.css';

const ExistList = ({ contacts }) => {
	const { page, perPage, onPage, onPerPage, headCells, onGetContact, checkSelected } = useExistList();

	const renderCells = headCells.map((cell) => <TableCell key={cell.id}>{cell.label}</TableCell>);

	const renderRows = contacts.slice(page * perPage, page * perPage + perPage).map((contact) => {
		const isItemSelected = checkSelected(contact[TY.ID]);
		return (
			<TableRow key={contact[TY.ID]} hover selected={isItemSelected} onClick={(e) => onGetContact(contact)}>
				<TableCell>{contact[TY.F_NAME]}</TableCell>
				<TableCell>{contact[TY.L_NAME]}</TableCell>
				<TableCell>{contact[TY.PHONE_WORK]}</TableCell>
				<TableCell>{contact[TY.EMAIL_WORK]}</TableCell>
				<TableCell>{contact.type}</TableCell>
			</TableRow>
		);
	});

	return (
		<section className={styles.section}>
			<TableContainer className={styles.table_container}>
				<Table size="small">
					<TableHead>
						<TableRow>{renderCells}</TableRow>
					</TableHead>
					<TableBody>{renderRows}</TableBody>
				</Table>
				<TablePagination
					component="div"
					rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
					colSpan={3}
					count={contacts.length}
					rowsPerPage={perPage}
					page={page}
					onRowsPerPageChange={onPerPage}
					onPageChange={onPage}
					ActionsComponent={ActionsComp}
				/>
			</TableContainer>
		</section>
	);
};

ExistList.propTypes = {
	contacts: estContactsType,
};

export default ExistList;
